// extracted by mini-css-extract-plugin
export var orderSummary = "_sw-0";
export var showMoreLessButton = "_sw-1";